import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { useForm } from '../../../hooks/useForm'
import { ApiUrl } from '../../../services/ApiRest';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

export const EndDay = () => {
    const [data, setdata] = useState([]);
    const [dataDay, setdataDay] = useState([]);
    const [sumTotalInventory, setsumTotalInventory] = useState(0);
    const [sumTotalFree, setsumTotalFree] = useState(0);
    const [sumTotalMermas, setSumTotalMermas] = useState(0);
    const [sumTotalEgress, setSumTotalEgress] = useState(0);
    const [cashFlow, setcashFlow] = useState(0);

    const fechaActual = new Date().toISOString().split('T')[0];

    const dataBeginDay = async () => {
        try {
            const response = await axios.get(ApiUrl + `beginning-day-list`);
            const responseData = response.data;

            if (responseData.length <= 0) {
                setdataDay(0)
            } else {
                const objetoFechaActual = responseData.find(item => item.date_bd === fechaActual);
                
                if (objetoFechaActual) {
                    setdataDay(objetoFechaActual.description_bd);

                } else {
                    setdataDay(0);
                }


            }
            const script = document.createElement("script");
            script.src = `/assets/dataTable/dataTable.js`;
            script.async = true;
            document.body.appendChild(script);
        } catch (error) {
            console.error(error);
        }
    };

    const dataList = async () => {
        try {
            const response = await axios.get(ApiUrl + `end-day-income-inventory-list`);
            const responseData = response.data;
            setdata(responseData);
            console.log('VALORES INVENTARIO:', responseData);
            /****************************************  INVENTORY **************************************************/
            // Inicializar una variable para la suma total
            let totalSum = 0;
            // Agrupar por secuential_bill_id y passengers_ci
            const groupedData = responseData.reduce((acc, item) => {
                if (item.sale_type === 'Inventario') {
                    const key = `${item.secuential_bill_id}-${item.passengers_ci} -${item.sale_type === 'Inventario'}`;
                    if (!acc[key]) {
                        acc[key] = {
                            secuential_bill_id: item.secuential_bill_id,
                            passengers_ci: item.passengers_ci,
                            sale_type: item.sale_type,
                            total_price: 0
                        };
                    }
                    const itemTotalPrice = item.quantity_prod * item.unitary_selling_price;
                    acc[key].total_price += itemTotalPrice;
                    totalSum += itemTotalPrice; // Acumular el total
                }
                return acc;
            }, {});
            // Imprimir en consola los valores calculados
            Object.values(groupedData).map(entry => {
                console.log(
                    `Factura: ${entry.secuential_bill_id}, Pasajero: ${entry.passengers_ci}, Pasajero: ${entry.sale_type}, Total: ${entry.total_price.toFixed(2)}`
                );
            });
            // Imprimir el total de todos los valores de 'total_price'
            console.log(`Suma Total: ${totalSum.toFixed(2)}`);
            setsumTotalInventory(totalSum.toFixed(2));
            /****************************************  END INVENTORY  **************************************************/
            /********************************************  FREE  *******************************************************/
            let totalSumFree = 0;
            const groupdataFree = responseData.reduce((acc, item) => {
                if (item.sale_type === 'Libre') {
                    // Crear una clave única para cada combinación de secuential_bill_id y passengers_ci
                    const key = `${item.secuential_bill_id}-${item.passengers_ci}`;
                    // Si no existe el grupo en el acumulador, inicialízalo
                    if (!acc[key]) {
                        acc[key] = {
                            secuential_bill_id: item.secuential_bill_id,
                            passengers_ci: item.passengers_ci,
                            total_price_free: 0
                        };
                    }
                    // Verificar que price_sale_free sea un número y acumularlo
                    if (!isNaN(item.price_sale_free)) {
                        acc[key].total_price_free += parseFloat(item.price_sale_free); // Aseguramos que sea un número

                    }
                }
                return acc;
            }, {});
            // Mostrar los resultados de cada grupo
            Object.values(groupdataFree).map(entry => {
                console.log(
                    `Factura: ${entry.secuential_bill_id}, Pasajero: ${entry.passengers_ci}, Total: ${entry.total_price_free.toFixed(2)}`
                );
                // Acumulamos el valor total_price_free en totalSumFree
                totalSumFree += entry.total_price_free;
            });
            // Mostrar la suma total de todos los productos 'Libre'
            console.log(`Suma total de productos 'Libre': ${totalSumFree.toFixed(2)}`);
            setsumTotalFree(totalSumFree.toFixed(2));
            /*******************************************  END FREE *****************************************************/

        } catch (error) {
            console.error(error);
        }
    };

    const dataListEgress = async () => {
        try {
            const response = await axios.get(ApiUrl + `end-day-egress-list`);
            const responseData = response.data;
            setdata(responseData);
            console.log('VALORES EGRESOS MERMAS:', responseData);
            /****************************************  MERMA **************************************************/
            const totalMermas = responseData
                .filter(item => item.type_em === 'Merma' && !isNaN(item.total_price_em))
                .reduce((sum, item) => sum + parseFloat(item.total_price_em), 0);

            /****************************************  END MERMA  **************************************************/
            /********************************************  EGRESO  *******************************************************/
            const totalEgress = responseData
                .filter(item => item.type_em === 'Egreso' && !isNaN(item.total_price_em))
                .reduce((sum, item) => sum + parseFloat(item.total_price_em), 0);
            /*******************************************  END EGRESO *****************************************************/
            console.log(`Suma total de Merma: ${totalMermas.toFixed(2)}`);
            console.log(`Suma total de Egreso: ${totalEgress.toFixed(2)}`);
            setSumTotalMermas(totalMermas.toFixed(2));
            setSumTotalEgress(totalEgress.toFixed(2));

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        dataList();

    }, []);
    useEffect(() => {
        dataBeginDay();

    }, []);



    useEffect(() => {
        dataListEgress();
    }, []);

    // Calcular total de ingresos - egresos cuando los valores cambien
    useEffect(() => {
        const total = (parseFloat(dataDay) + parseFloat(sumTotalFree) + parseFloat(sumTotalInventory)) - parseFloat(sumTotalEgress) - parseFloat(sumTotalMermas);
        setcashFlow(total.toFixed(2));
    }, [sumTotalFree, sumTotalInventory, sumTotalEgress]);


    return (
        <div>
            <div className='row'>
                <div className='col-12 '>
                    <div className="card">
                        <div className="card-header">
                            FIN DE DÍA {fechaActual}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                {/* Tabla de Ingresos */}
                                <div className="col-md-6">
                                    <table className="table table-bordered text-center">
                                        <thead className="table-success">
                                            <tr>
                                                <th>INGRESOS</th>
                                                <th>VALORES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Ingresos de ventas sin inventario del día</td>
                                                <td>{sumTotalFree}</td>
                                            </tr>
                                            <tr>
                                                <td>Ingresos de ventas de inventario del día</td>
                                                <td>{sumTotalInventory}</td>
                                            </tr>
                                            <tr>
                                                <td>Inicio de día</td>
                                                <td>{dataDay}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Tabla de Egresos */}
                                <div className="col-md-6">
                                    <table className="table table-bordered text-center">
                                        <thead className="table-danger">
                                            <tr>
                                                <th>EGRESOS</th>
                                                <th>VALORES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Total egreso diario</td>
                                                <td>{sumTotalEgress}</td>
                                            </tr>
                                            <tr>
                                                <td>Total egreso merma</td>
                                                <td>{sumTotalMermas}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <br></br>
                            <br></br>
                            <br></br>

                            {/* Tabla de Valor TOTAL */}
                            <center>
                                <div className="col-md-6">
                                    <table className="table table-bordered text-center">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>TOTAL DINERO EN CAJA</th>
                                                <th>{cashFlow}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer theme="colored" />

        </div>
    )
}
